export const environment: any = {
  production: true,
  // tinyMceKey: 'nfj6w8hc6i2j2nlr19s0ebfd8s5vwwziz7431xvng8u8emw7',
  tinyMceKey: 'zpeml00qcb4dhnwsdedtxr0fuca8fvyxs9qm85xr90sad0mn',
  AlertBeforeTimeOutSeconds:300,
};
